export default {
  'department.department': 'Department',
  'department.name': 'Department Name',
  'department.perisanname': 'Persian department name',
  'department.englishname': 'English department name',
  'department.code': 'Department Code',
  'department.add': 'Add Department',
  'department.title': 'Department Management',
  'department.departmentdel': 'Delete Department',
  'department.departmentadd': 'Department Added Successfully!',
  'department.departmentdelete': 'Department Deleted Successfully!',
  'department.deleteerror': 'Record has been used by other Records',
  'department.departmentaddInformation':
    'Your information has been edited successfully',
};
